import { WidgetLineGraph } from '../Widgets';
import { connect } from 'react-redux';
import { getConversionData } from '../../redux/actions/conversion';
import { formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetConversion',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.conversion.WidgetConversion && state.conversion.WidgetConversion.data && state.filter.filters.startDate && state.filter.filters.endDate ? Object.values(state.conversion.WidgetConversion.data.reduce((acc, curr) => ({
    nsbm: [...acc.nsbm, {value: (curr.nsbm / curr.nv) * 100, key: formatDateFromRange(curr.dt, state.filter.filters), label:'nsbm', dt:curr.dt}],
    ns: [...acc.ns, {value: (curr.ns / curr.nv) * 100, key: formatDateFromRange(curr.dt, state.filter.filters), label:'ns', dt:curr.dt}]
  }), {
    nsbm: [],
    ns: []
  })) : [],
  exportData: state.conversion.WidgetConversion && state.conversion.WidgetConversion.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.WidgetConversion.data.map(item => ({
    date: item.dt,
    "Submission Rate": (item.nsbm / item.nv) * 100,
    "Subscriber Rate": (item.ns / item.nv) * 100
  })) : [],
  info: [],
  keys: ['Submission Rate', 'Subscriber Rate'],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.conversion.WidgetConversion && state.conversion.WidgetConversion.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.conversion.WidgetConversion
    && state.conversion.WidgetConversion.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  shouldLoadData: !state.conversion.WidgetConversion || (!state.conversion.WidgetConversion.loaded && !state.conversion.WidgetConversion.loading && !state.conversion.WidgetConversion.error),
  drillOptions: ['Category', 'OS', 'Partner', 'Page', 'Campaign'],
  drillData: [
    {
      label: 'Category',
      param: 'cat',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillConversion',
      widgetTitle: 'Conversion Data by Category'
    },
    {
      label: 'OS',
      param: 'os',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillConversion',
      widgetTitle: 'Conversion Data by OS'
    },
    {
      label: 'Partner',
      param: 'partnerId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillConversion',
      widgetTitle: 'Conversion Data by Partner'
    },
    {
      label: 'Page',
      param: 'pageId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillConversion',
      widgetTitle: 'Conversion Data by Page'
    },
    {
      label: 'Campaign',
      param: 'campaignId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillConversion',
      widgetTitle: 'Conversion Data by Campaign'
    }
  ],
  customFilter: true,
  customFilterAcceptedParams: ['pageId', 'os', 'campaignId', 'flowId', 'partnerId']
})

const mapDispatchToProps = { fetchData: getConversionData };

export default connect(mapStateToProps, mapDispatchToProps)(WidgetLineGraph)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetConversionConnected.js